import React from 'react';

import Checkbox, { LabelPlacement } from '@zvuk-b2b/react-uikit/ui/Checkbox';
import styles from './index.module.scss';
import { DATA_TEST_IDS } from '../../consts';
import { ChooseItemListItemProps } from './types';

const ChooseItemListItem: React.FC<ChooseItemListItemProps> = ({
  currentItem,
  onChange,
  isChecked,
  children,
  isDisabled = false,
  isLoading = false,
}) => (
  <div
    className={styles.container}
    data-testid={DATA_TEST_IDS.MEDIAFILE_SELECTION_ROW}>
    <Checkbox
      key={currentItem?.id}
      elementId={DATA_TEST_IDS.MEDIAFILE_SELECTION_CHECKBOX(currentItem?.id ?? '0')}
      isChecked={isChecked}
      labelPlacement={LabelPlacement.RIGHT}
      className={styles.checkbox}
      labelClassName={styles.label}
      onChange={(value: boolean) => {
        if (!currentItem) return;
        onChange(value, currentItem);
      }}
      isDisabled={isDisabled}
      isLoading={isLoading}>
      {children}
    </Checkbox>
  </div>
);

export default ChooseItemListItem;
